export type Room = {
  id: string;
  name: string;
  type: string;
  price: number;
  status: "available" | "occupied";
  guests: number;
  size: string;
  image: string;
  images: string[];
  description: string;
  amenities: string[];
};

export const rooms: Room[] = [
  {
    id: "garden-suite",
    name: "Garden Suite",
    type: "Premium suite",
    price: 185000,
    status: "available",
    guests: 2,
    size: "42 m²",
    image: "https://images.unsplash.com/photo-1616486338812-3dadae4b4ace?auto=format&fit=crop&w=1200&q=85",
    images: [
      "https://images.unsplash.com/photo-1616486338812-3dadae4b4ace?auto=format&fit=crop&w=1400&q=85",
      "https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?auto=format&fit=crop&w=1400&q=85",
      "https://images.unsplash.com/photo-1600566753086-00f18fb6b3ea?auto=format&fit=crop&w=1400&q=85",
    ],
    description: "A calm, light-filled suite with a private garden outlook, a king bed, and a generous lounge space for slow mornings.",
    amenities: ["King bed", "Garden view", "Breakfast included", "Smart TV"],
  },
  {
    id: "skyline-deluxe",
    name: "Skyline Deluxe",
    type: "Deluxe room",
    price: 145000,
    status: "occupied",
    guests: 2,
    size: "34 m²",
    image: "https://images.unsplash.com/photo-1590490360182-c33d57733427?auto=format&fit=crop&w=1200&q=85",
    images: [],
    description: "A refined city-facing room designed for restorative stays.",
    amenities: ["Queen bed", "City view", "Workspace", "Rain shower"],
  },
  {
    id: "coastal-family",
    name: "Coastal Family Room",
    type: "Family room",
    price: 220000,
    status: "available",
    guests: 4,
    size: "55 m²",
    image: "https://images.unsplash.com/photo-1582719478250-c89cae4dc85b?auto=format&fit=crop&w=1200&q=85",
    images: [
      "https://images.unsplash.com/photo-1582719478250-c89cae4dc85b?auto=format&fit=crop&w=1400&q=85",
      "https://images.unsplash.com/photo-1566665797739-1674de7a421a?auto=format&fit=crop&w=1400&q=85",
      "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?auto=format&fit=crop&w=1400&q=85",
    ],
    description: "Room to stretch out together, with two sleep zones, a welcoming sitting area, and easy access to the pool terrace.",
    amenities: ["Two queen beds", "Pool access", "Mini fridge", "Family bath"],
  },
  {
    id: "courtyard-classic",
    name: "Courtyard Classic",
    type: "Classic room",
    price: 110000,
    status: "occupied",
    guests: 2,
    size: "28 m²",
    image: "https://images.unsplash.com/photo-1601918774946-25832a4be0d6?auto=format&fit=crop&w=1200&q=85",
    images: [],
    description: "A comfortable and thoughtful room with a peaceful courtyard view.",
    amenities: ["Queen bed", "Courtyard view", "Coffee station", "Wi-Fi"],
  },
];
